import {addEditCollectionApi} from '../../Collections/ApisFunctions/Add&EditCollection';
import {slug as createSlug} from 'github-slugger';

const CreateCollection = async data => {
  try {
    const results = data.listings || data.reports || data.data;

    const listingInspect = results?.map(r => r?.listing_id);
    // extract null values from listingInspect while array [null, null, null]
    const listingIds = listingInspect?.filter(
      r => r !== null && r !== undefined,
    );

    if (listingIds.length === 0) {
      return {
        success: false,
        error: 'No listings found',
      };
    }

    // Prepare collection data
    const collectionData = {
      expirable: false,
      medium: [1, 2, 3],
      scope_type: 4,
      condition_type: 2,
      manual_ids: listingIds,
      active: true,
      view_type: 'horizontal',
      background_color: '#FFFFFF',
      order_by: 0,
      title: `${data.title}`,
      slug: createSlug(`${data.title}`),
    };

    // Call the API
    const response = await addEditCollectionApi({
      data: collectionData,
      isEdit: false,
    });

    return {
      success: true,
      data: 'Collection created successfully',
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export default CreateCollection;
